import { render, staticRenderFns } from "./feedback_delete.vue?vue&type=template&id=c96c8b02&scoped=true&"
import script from "./feedback_delete.vue?vue&type=script&lang=js&"
export * from "./feedback_delete.vue?vue&type=script&lang=js&"
import style0 from "./feedback_delete.vue?vue&type=style&index=0&id=c96c8b02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c8b02",
  null
  
)

export default component.exports